import { ASSETS, CONTACT, SLOGANS } from "@/data/content";
import { img } from "@/data/images";
import { t } from "@/data/texts";
import { FliesSlogan } from "@/components/effects/Effects";
import { Instagram, Facebook, Youtube } from "lucide-react";

export default function Footer() {
  const address = t("contact.address", CONTACT.address);
  const phone = t("contact.phone", CONTACT.phone);
  const email = t("contact.email", CONTACT.email);
  const phoneHref = `tel:${phone.replace(/[^+\d]/g, "")}`;
  return (
    <footer className="relative bg-black border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img src={img("logoGate", ASSETS.logoGate)} alt="GATE ESCAPE" className="h-10 w-auto mb-4" />
            <p className="text-sm text-neutral-500 leading-relaxed">
              Surová Psychoactive Escapecore hra v autentickém urbex stylu. Pouze pro odvážné 18+.
            </p>
          </div>
          <div className="text-sm text-neutral-400 space-y-2">
            <p className="font-head text-neutral-200 mb-3">KONTAKT</p>
            <p>{address}</p>
            <p><a href={phoneHref} className="hover:text-nv">{phone}</a></p>
            <p><a href={`mailto:${email}`} className="hover:text-nv">{email}</a></p>
          </div>
          <div className="text-sm text-neutral-400 space-y-2">
            <p className="font-head text-neutral-200 mb-3">ODKAZY</p>
            <a href="#rezervace" className="block hover:text-nv">Rezervace</a>
            <a href="#poukazy" className="block hover:text-nv">Dárkové poukazy</a>
            <a href="#faq" className="block hover:text-nv">Časté dotazy</a>
            <a href="/ochrana-osobnich-udaju" className="block hover:text-nv" data-testid="footer-gdpr-link">Ochrana osobních údajů</a>
            <a href="/admin" className="block hover:text-nv">Administrace</a>
            <div className="flex items-center gap-4 pt-3">
              {CONTACT.instagram && <a href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-nv"><Instagram className="w-5 h-5" /></a>}
              {CONTACT.facebook && <a href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-nv"><Facebook className="w-5 h-5" /></a>}
              {CONTACT.youtube && <a href={CONTACT.youtube} target="_blank" rel="noreferrer" aria-label="YouTube" className="hover:text-nv" data-testid="footer-youtube"><Youtube className="w-5 h-5" /></a>}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center">
          <p className="font-head text-lg text-neutral-400 mb-6">
            <FliesSlogan text={SLOGANS[3]} className="vhs-glitch" />
          </p>
          <p className="text-xs text-neutral-600 tracking-widest">
            © {new Date().getFullYear()} GATE ESCAPE · HUBERT — PSYCHOACTIVE ESCAPECORE
          </p>
        </div>
      </div>
    </footer>
  );
}
